import templateComponents from '../../../Template/theme/components'
import scorecard from './scorecard'
import quickview from './quickview'

export default {
    ...templateComponents,
    scorecard,
    quickview
}